export const GOOGLE_ADS_CONFIG = {
  // Replace these with your actual Google Ads IDs
  ADS_CLIENT_ID: 'ca-pub-1991975343768977', // Your Google AdSense publisher ID
  ENABLED: process.env.NODE_ENV === 'production', // Only enable ads in production
  // Define different ad slots for different positions
  AD_SLOTS: {
    LEFT_SIDEBAR: '1269916264', // Your existing sidebar ad slot
    RIGHT_SIDEBAR: '2617515313', // Your existing sidebar ad slot
  }
};

// Ad unit sizes
export const AD_SIZES = {
  RESPONSIVE: 'auto',
  LARGE_RECTANGLE: '336x280',
  MEDIUM_RECTANGLE: '300x250',
  LEADERBOARD: '728x90',
  SKYSCRAPER: '120x600',
} as const;

// Ad positions in the application
export const AD_POSITIONS = {
  HEADER: 'header',
  LEFT_SIDEBAR: 'left_sidebar',
  RIGHT_SIDEBAR: 'right_sidebar',
  CONTENT: 'content',
  FOOTER: 'footer',
} as const; 